module.exports = __webpack_public_path__ + "01ea978f/img/arrow-share-icon.00a12c29.svg";